// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__NCLE7","controls":"styles_controls__9PwyP","charLimit":"styles_charLimit__2fGm3","input":"styles_input__7cRzQ","send":"styles_send__Jd4bu"};